<script lang="ts">
  import Text from '../../common/components/Text.svelte';

  // export let title: string = 'eXtra Blog';
  // export let subTitle: string = 'Welcome to eXtra Blog, your premier destination where innovation intersects with convenience. <br> Whether you are a tech aficionado, a casual consumer, or a seasoned professional, our blog serves as your compass in navigating the ever-evolving landscape of electronics and home appliances.';
</script>

<section class="blog-header-section">
  <div class="blog-header">
    <h3 class="title"><Text key="extra.ampliance.blog.title" /></h3>
    <div class="subtitle">
      <span>
        <Text key="extra.ampliance.blog.subtitle.text.one" />
      </span>
      <!-- <span>
                <Text key="extra.ampliance.blog.subtitle.text.two"/>
            </span> -->
    </div>
  </div>
</section>

<style lang="scss">
  @import '../../common/styles/colors.new.scss';
  .blog-header-section {
    text-align: center;
    .blog-header {
      display: flex;
      flex-direction: column;
      gap: 8px;
      color: $neutral-dark-01;
      @include desktop-max-width {
        gap: 4px;
      }
      .title {
        font-size: 38px;
        font-weight: 700;
        line-height: 64px;
        margin: 0;
        @include desktop-max-width {
          font-size: 20px;
          line-height: 22px;
        }
      }
      .subtitle {
        font-size: 18px;
        font-weight: 400;
        line-height: 22px;
        margin: 0;
        display: flex;
        flex-direction: column;
        @include desktop-max-width {
          font-size: 14px;
          line-height: 18px;
          color: $neutral-dark-02;
        }
      }
    }
  }
</style>
